
export class EntEconomicActivityTypes {
  id: number | null = null;
  code: string | null = null;
  alias: string | null = null;
  nameKy: string = '';
  nameRu: string = '';
  parentId: number| null = null;
}
